import {
	RavenBadge,
	RavenButton,
	RavenInputField,
	RavenModal,
	toast,
} from '@ravenpay/raven-bank-ui';
import React, { useEffect, useState } from 'react';
import '../../../../../pages/dashboard/bankbox/fee-details/style/CreateFeeCategoryModal.css';
import './style/index.css';
import * as XLSX from 'xlsx';
import Skeleton from 'react-loading-skeleton';
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import RootState from '../../../../../redux/types';
import { icons } from '../../../../../assets/icons';
import { filterEmptyColumns } from '../../../../../utils/helper/Helper';
import Copy from '../../../../../components/common/copyCheck';
import CodePreview from '../../../../../components/common/codePreview/CodePreview';
import BadgeComponent from '../../../../../components/common/badge/BadgeComponent';
import { bankboxAPI } from '../../../../../redux/bankbox';

type Modal = {
	onClose: Function;
	visible: boolean;
	direction: string;
	title: string;
	amountt: number;
	reference: string;
	transactionType: string;
	meta?: string;
	onClick: Function;
	directionTitle?: string;
	status?: string;
	isLoadingDetails?: boolean;
	singleObj?: any;
	content: {
		label: string;
		value: string;
		copy?: boolean;
		trim?: boolean;
		dontSHow?: boolean;
	}[];
};

const RequestModal = ({
	onClose,
	reference,
	transactionType,
	visible,
	title,
	content,
	direction,
	amountt,
	onClick,
	directionTitle,
	isLoadingDetails = false,
	meta,
	status,
	singleObj,
	...props
}: Modal) => {
	const [shareModalVisible, setShareModalVisible] = React.useState(false);
	const [collapsed, setCollapsed] = React.useState(true);
	const [showDisputeModal, setShowDisputeModal] = useState(false);
	const [showSkeleton, setShowSkeleton] = useState(true);
	const [description, setDescription] = useState('');
	const [account_number, setAccountNumber] = useState('');
	const [customer_name, setCustomerName] = useState('');
	const [transaction_id, setTransactionId] = useState('');
	const [note, setNote] = useState('');
	const [amount, setAmount] = useState('');
	const [customer_phone, setCustomerPhone] = useState('');
	const [bank_name, setBankName] = useState('');
	const [type, setType] = useState('');
	const [email, setEmail] = useState('');
	const [step, setStep] = useState(1);
	const stepList = [1, 2];
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { loading } = useSelector((state: RootState) => state.bankbox);

	useEffect(() => {
		const timer = setTimeout(() => {
			setShowSkeleton(false);
		}, 5000); // ⏱️ 2 seconds delay (adjust as needed)

		return () => clearTimeout(timer);
	}, []);

	const dispatch = useDispatch();

	const [formData, setFormData] = React.useState({
		fname: '',
		lname: '',
		bvn: '',
		nin: '',
		email: '',
		phone: '',
		note: '',
		amount: '',
		transactionType: '',
		device_label: '',
		delivery_location: '',
		delivery_option: '',
		delivery_address: '',
		delivery_lga: '',
		transaction_id: '',
		customer_phone: '',
		delivery_state: '',
		landmark: '',
		purpose: '',
		type: '',
		id: '',
		customer_name: '',
		region: { value: undefined, label: undefined },
		number_of_devices: 0,
		business_address: '',
		fee_category: { value: undefined, label: undefined } as any,
		bank: { value: undefined, label: undefined } as any,
		bank_code: '',
		account_number: '',
		bank_name: '',
		quantity: '',
		status: 'Pending',
		created_at: new Date().toISOString(),
		account_name: '',
		settlement_date: '',
		daily_payout_time: '00:00',
	});

	function filterEmptyColumns(obj: Record<string, any>) {
		const alwaysKeep = ['note'];
		return Object.fromEntries(
			Object.entries(obj).filter(
				([key, val]) =>
					alwaysKeep.includes(key) || (val !== '---' && val !== '---')
			)
		);
	}

	const handleSubmit = async () => {
		// First, parse the amount and handle empty or invalid values
		const cleanedAmount = amount
			? parseFloat(amount.replace(/[^\d.-]/g, ''))
			: 0;

		const reference = singleObj?.reference;

		const val = {
			...formData,
			reference: reference,
			device_label: formData.device_label as unknown as string,
			region: formData.region.label as unknown as string,
			fee_ref: String(formData?.fee_category?.reference),
			bank_name: formData?.bank?.label,
			bank_code: formData?.bank?.value,
			account_number: formData?.account_number,
			account_name: formData?.account_name,
			email: formData.email,
			quantity: formData.number_of_devices,
			business_name: formData.device_label,
			phone: formData.phone,
			amount: cleanedAmount,
			status: 'Pending',
			created_at: new Date().toISOString(),
			transaction_id: formData.id,
			customer_name: `${formData.fname} ${formData.lname}`,
			customer_phone: formData.phone,
			type: transactionType,
			note: note ?? '',
		};

		delete val.fee_category;
		delete val.bank;

		try {
			const resp = await dispatch(
				bankboxAPI.raiseDispute(filterEmptyColumns(val) as any)
			);
			//('API response:', resp);
			//('Payload before dispatch:', val);

			//('Payload before dispatch:', val);

			if (resp.payload?.status === 'success') {
				await dispatch(
					bankboxAPI.getAllBankBoxRequest({
						per_page: 20,
						page: 1,
					})
				);
			} else {
				// console.error('Dispute submission failed:', resp.payload?.message);
			}
		} catch (error) {
			// console.error('Error submitting dispute:', error);
		}
	};

	const handleDescriptionChange = (
		e: React.ChangeEvent<HTMLTextAreaElement>
	) => {
		setDescription(e.target.value); // Update description state on change
	};

	const isFormValid = () => {
		return note.trim() !== '';
	};

	const [modalType, setModalType] = React.useState<'transaction' | 'dispute'>(
		'transaction'
	);

	const handleShareClick = () => {
		setModalType('dispute');
		setShareModalVisible(true);
	};

	const handleClose = () => {
		setFormData({
			fname: '',
			lname: '',
			bvn: '',
			nin: '',
			email: '',
			phone: '',
			note: '',
			amount: '',
			transactionType: '',
			device_label: '',
			delivery_location: '',
			delivery_option: '',
			delivery_address: '',
			delivery_lga: '',
			transaction_id: '',
			customer_phone: '',
			delivery_state: '',
			landmark: '',
			purpose: '',
			type: '',
			id: '',
			customer_name: '',
			region: { value: undefined, label: undefined },
			number_of_devices: 0,
			business_address: '',
			fee_category: { value: undefined, label: undefined } as any,
			bank: { value: undefined, label: undefined } as any,
			bank_code: '',
			account_number: '',
			bank_name: '',
			quantity: '',
			status: 'Pending',
			created_at: new Date().toISOString(),
			account_name: '',
			settlement_date: '',
			daily_payout_time: '00:00',
		});
		setNote('');
		setDescription('');
		setStep(1);
		setModalType('transaction');

		onClose();
	};

	function formatStatus(status: string | number) {
		let s;
		// 		0 = pending, 1 = approved, 2 = dispatched, 3 = delivered
		// [3:17 PM] 4 = declined
		if (status === 0 || status === 'pending') {
			s = 'pending';
		}
		if (status === 1) {
			s = 'approved';
		}
		if (status === 2) {
			s = 'dispatched';
		}
		if (status === 3) {
			s = 'delivered';
		}
		if (status === 4) {
			s = 'declined';
		}
		return s;
	}
	function formatStatusColor(status: string | number) {
		let s;
		// 		0 = pending, 1 = approved, 2 = dispatched, 3 = delivered
		// [3:17 PM] 4 = declined
		if (status === 0 || status === 'pending') {
			s = 'yellow';
		}
		if (status === 1) {
			s = 'green';
		}
		if (status === 2) {
			s = 'purple';
		}
		if (status === 3) {
			s = 'info';
		}
		if (status === 4) {
			s = 'blue';
		}
		return s;
	}

	// Modal content for Transaction
	const renderTransactionModalContent = () => (
		<div
			onClick={() => {
				//(content);
				//(status);
			}}
			className="transaction-details-modal details-modal-wrap "
		>
			<h5 className="details-modal-wrap__title">
				{title || 'Transfer Details'}
			</h5>

			<div className="details-modal-wrap__content">
				<div className="content__main">
					<div
						className={`main__account-details ${!collapsed && 'collapsed'} ${
							collapsed && 'not-collapsed'
						}`}
					>
						{direction && (
							<div className="account-details__item">
								<p>{directionTitle || 'Direction'}</p>
								<div>
									<div className={`badge badge--${direction}`}>
										<figure>
											{icons[`arrow_narrow_${direction.toLowerCase()}`]}
										</figure>
										<p>
											{direction?.slice(0, 1).toUpperCase() +
												direction?.slice(1, 10)}
										</p>
									</div>
								</div>
							</div>
						)}
						{content?.map((chi, idx) => {
							if (chi?.dontSHow) {
								return <React.Fragment key={idx}></React.Fragment>;
							}
							if (chi?.label === 'Status') {
								return (
									<div key={idx} className="account-details__item">
										<p>{chi?.label}</p>
										<span className="item__value">
											<RavenBadge
												type={`${formatStatusColor(status as any)}`}
												text={formatStatus(status as any)}
											/>
										</span>
									</div>
								);
							}
							return (
								<div key={idx} className="account-details__item">
									<p>{chi?.label}</p>
									<span className="item__value">
										<p>
											{chi?.trim
												? chi?.value?.length > 20
													? chi?.value?.slice(0, 20) + '...'
													: chi?.value
												: chi.value
												? chi.value
												: '--'}
										</p>
										{chi?.value?.length > 5 && chi.copy && (
											<figure>{<Copy text={chi.value} />}</figure>
										)}
									</span>
								</div>
							);
						})}
						{/* {status ? (
							<>
								<div className="account-details__item">
									<p>{`Status`}</p>
									<div>
										<RavenBadge
											type={`${formatStatusColor(status)}`}
											text={formatStatus(status)}
										/>
									</div>
								</div>
							</>
						) : (
							''
						)} */}
					</div>
					{meta && (
						<div className={`meta_preview_wrapper ${!collapsed && 'expanded'}`}>
							<div className={`meta_preview ${collapsed && 'collapsed'}`}>
								<CodePreview json={JSON.parse(meta)} />
							</div>
						</div>
					)}

					<div className="trx-modal__button-wrap">
						{meta && (
							<button onClick={() => setCollapsed(!collapsed)}>
								<p>{collapsed ? 'View MetaData' : 'Collapse MetaData'}</p>
								<figure>{icons.code}</figure>
							</button>
						)}
						{/* <button>
							<p>Download File</p>
							<figure>{icons.export}</figure>
						</button> */}
						{/* <button onClick={handleShareClick}>
							<p>Raise Dispute</p>
						</button> */}
					</div>
				</div>
			</div>
		</div>
	);

	// Modal content for Dispute
	const renderDisputeModalContent = () => (
		<>
			<div className="transaction-details-modal details-modal-wrap">
				<h5 style={{ fontSize: '20px', marginBottom: '16px' }}>Dispute</h5>

				{/* Header Section */}
				<div
					style={{
						backgroundColor: '#F7F7F7',
						padding: '2rem',
						borderRadius: '1rem',
						marginBottom: '2rem',
					}}
				>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}
					>
						<div>
							<span style={{ fontSize: '1.4rem', fontWeight: 400 }}>
								Reference •{' '}
							</span>
							{showSkeleton && isLoadingDetails ? (
								<Skeleton width={100} height={20} />
							) : (
								<span style={{ fontSize: '1.4rem', fontWeight: 400 }}>
									{reference || '---'}
								</span>
							)}
						</div>
						<button
							style={{
								background: '#FFF',
								fontSize: '1.1rem',
								border: 'none',
								padding: '1rem',
								borderRadius: '2rem',
								cursor: 'pointer',
							}}
							onClick={() => setModalType('transaction')}
						>
							Back to Transaction
						</button>
					</div>

					<div
						style={{ marginTop: '1.2rem', fontSize: '1.4rem', fontWeight: 500 }}
					>
						{showSkeleton && isLoadingDetails ? (
							<Skeleton width={120} height={20} />
						) : (
							<>
								₦{amountt?.toLocaleString()} •{' '}
								<span style={{ color: 'gray' }}>{singleObj.type || '---'}</span>
							</>
						)}
					</div>
				</div>

				{/* Step Switch */}
				<div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
					<>
						<RavenInputField
							color="black-light"
							label="Discription"
							labelClassName="my_custom_class"
							labelColor="purple-light"
							onActionClick={function noRefCheck() {}}
							textareaColumn={30}
							textareaRow={5}
							type="textarea"
							value={note}
							// style={{ marginBottom: '1rem' }}
							onChange={(e: any) => {
								setNote(e.target.value);
								setFormData((prev) => ({ ...prev, note: e.target.value }));
							}}
							placeholder="Write your thoughts here..."
						/>
						{/* File Upload */}
						<div className="form-section" style={{ marginBottom: '2rem' }}>
							<RavenInputField
								label="Upload a file"
								type="upload"
								color="purple-light"
								onChange={(e: any) => {
									//(e);
								}}
							/>
							<p style={{ marginTop: '1rem' }}>
								Maximum file size acceptable for upload is 2MB
							</p>
						</div>

						<RavenButton
							color="deep-green-dark"
							label="Raise Dispute"
							// size="big"
							loading={loading}
							disabled={!isFormValid() || !note}
							style={{ width: '100%' }}
							onClick={handleSubmit}
						/>
					</>
				</div>
			</div>
		</>
	);

	const checKLabel = () => {
		if (modalType === 'transaction') {
			return '';
		} else {
			if (step === 1) {
				return '';
			} else {
				return 'Raise Dispute';
			}
		}
	};

	return (
		<>
			<RavenModal
				btnLabel={checKLabel()}
				btnColor="deep-green-light"
				className={'trx-modal-main-wrapper'}
				onClose={handleClose} // Ensures closing the modal from either view
				visble={visible}
				onBtnClick={onClick as () => void}
				{...props}
			>
				{modalType === 'transaction'
					? renderTransactionModalContent()
					: renderDisputeModalContent()}
			</RavenModal>
		</>
	);
};

export default RequestModal;
